import { ReactNode } from 'react';

export const Row = ({ children }: { children: ReactNode }) => {
	return <div style={{ display: 'flex', flexDirection: 'row' }}>{children}</div>;
};
